var React = require('react');

function BarGroup (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M79 67H213V91H79V67Z","fill":"#00B2A9","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M189 121.999H324V146.999H189V121.999Z","fill":"#626262","fillOpacity":"0.231373","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M122 208.999H256V232.999H122V208.999Z","fill":"#626262","fillOpacity":"0.231373","key":2}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15 153.999H111V177.999H15V153.999Z","fill":"#041E42","key":3}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 0H111V24H0V0Z","fill":"#626262","fillOpacity":"0.231373","key":4})]);
}

BarGroup.defaultProps = {"width":"324","height":"233","viewBox":"0 0 324 233","fill":"none"};

module.exports = BarGroup;

BarGroup.default = BarGroup;
